import { css } from 'styled-components'

const extendStylesDropdownSupervisor = css`
    width: 177px;
`

export {
    extendStylesDropdownSupervisor
}